/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useState, useEffect } from "react";
//#endregion
//#region Styles
import { Column } from "components/styles";
import { HeaderAdviser } from "./styles";
//#endregion
//#region Components
import SchedulesWrapper from "../SchedulesWrapper/SchedulesWrapper";
//#endregion
//#region Icons
import Header from "./components/Header/Header";
//#endregion
//#region Utils
import { QUANTITY_PER_PAGE } from "views/components/Schedules/utils/constants";
//#endregion

const SchedulesByAllAdvisers = ({
    dateFiltered,
    dataFetch: {
        advisers,
        schedulesByAllAdvisers
    },
    reloadData,
    filterFields,
    dataPaginator,
    isBoss
}) => {
    const [quantityPages, setQuantityPages] = useState();
    const [schedulesData, setSchedulesData] = useState({
        headers: [],
        body: []
    });
    //#region Effects
    useEffect(fillQuantityPages, [advisers]);
    useEffect(fillSchedules, [schedulesByAllAdvisers]);
    //#endregion
    //#region Functions
    function fillSchedules() {
        const skip = (dataPaginator.currentPage - 1) * QUANTITY_PER_PAGE;
        const currentRecords = [...advisers].splice(skip, QUANTITY_PER_PAGE);
        const offsetColumns = Array(QUANTITY_PER_PAGE - currentRecords.length).fill(null);
        const currentRecordsWithOffsetColumns = currentRecords.concat(offsetColumns);
        const data = {
            headers: currentRecordsWithOffsetColumns.map((adviser) => ({
                render: (
                    <HeaderAdviser className="main-content">
                        {!adviser 
                        ? <span></span>
                        : <span title={adviser.name}>{adviser.name}</span>}
                    </HeaderAdviser>
                )
            })),
            body: currentRecordsWithOffsetColumns.map(adviser => {
                if (!adviser) 
                    return null;   
                const column = schedulesByAllAdvisers.find(item => item.adviser.code === adviser.code);
                if (!column)
                    return {
                        adviser: null,
                        appointments: [],
                        filteringByStudent: false
                    };
                return { ...column };
            })
        };
        setSchedulesData(data);
    }
    function fillQuantityPages() {
        setQuantityPages(Math.ceil(advisers.length/QUANTITY_PER_PAGE));
    }
    //#endregion
    return (
        <Column gap="30px">
            <Header date={filterFields.date}
                dataPaginator={{
                    quantityPages,
                    totalRecords: advisers.length,
                    ...dataPaginator
                }}/>
            <SchedulesWrapper
                date={dateFiltered}
                data={schedulesData}
                reloadData={reloadData}
                isBoss={isBoss}/>
        </Column>
    );
}

export default SchedulesByAllAdvisers;